import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { STATUS_MAPPER_CLASS } from '../../../mappers/status.mapper';

/**
 * @deprecated
 */
@Directive({
  selector: '[appStatus]',
})
export class StatusDirective implements OnInit {
  @Input('appStatus') status: string | null | undefined = '';

  constructor(private readonly _el: ElementRef, private readonly _renderer: Renderer2) {}

  ngOnInit() {
    this.setColor();
  }

  private setColor() {
    if (this.status) {
      const result = STATUS_MAPPER_CLASS(this.status.toUpperCase());
      this._renderer.setAttribute(this._el.nativeElement, 'class', 'green');
    }
  }
}
